import * as React from 'react';
import { Props } from 'react';
import { connect, Dispatch } from 'react-redux';
import { withRouter, RouteComponentProps } from 'react-router-dom';
import * as queryString from 'query-string';

import { AppState } from '../../../reducers';

import {
    setUserPhoneAction,
    setChannelUserIdAction,
    setChannelIdAction,
    setUserLangAction, setTariffIdAction
} from '../../../actions/user';

import { SuccessView } from './SuccessView';
import i18next from 'i18next';

interface RouteProps extends RouteComponentProps<{}> {
    match: any;
    history: any;
}

interface SuccessContainerProps extends Props<SuccessContainer> {
    userId: string;
    channelId: string;
    channelUserId: string;
    lang: string;
    tariffId: number;
}

interface SuccessContainerDispatch extends Props<SuccessContainer> {
    setPhone: (phone: string) => any;
    setChannelUserId: (channelUserId: string) => any;
    setChannelId: (channelId: string) => any;
    setLang: (lang: string) => any;
    setTariffId: (tariffId: number) => any;
}

function mapProps(state: AppState, props: SuccessContainerProps): SuccessContainerProps {
    return {
        lang: state.userState.lang,
        userId: state.userState.userId,
        channelUserId: state.userState.channelUserId,
        channelId: state.userState.channelId,
        tariffId: state.userState.tariffId
    };
}

function mapDispatch(dispatch: Dispatch<any>): SuccessContainerDispatch {
    return {
        setLang: (lang: string) => dispatch(setUserLangAction(lang)),
        setPhone: (phone: string) => dispatch(setUserPhoneAction(phone)),
        setChannelUserId: (channelUserId: string) => dispatch(setChannelUserIdAction(channelUserId)),
        setChannelId: (channelId: string) => dispatch(setChannelIdAction(channelId)),
        setTariffId: (tariffId: number) => dispatch(setTariffIdAction(tariffId))
    };
}

const messengerLinks = {
    telegram: 'tg://resolve?domain=APCG_Konsierge_bot',
    whatsapp: 'https://wa.me/74997531065',
    viber: 'https://chats.viber.com/konsierge',
    facebook: 'http://m.me/KonsiergeMobileApp'
};

class SuccessContainer extends React.Component<SuccessContainerProps & SuccessContainerDispatch & RouteProps> {
    async componentDidMount() {
        const { history, setPhone, setChannelUserId, setChannelId, setLang, setTariffId, lang } = this.props;
        if (history.location.search) {
            const params = queryString.parse(history.location.search);
            const phone = params.phone;
            const channelUserId = params.user_id;
            const channel = params.channel_id;
            const tariff_id = params.tariff_id;

            const language = params.lang;
            if (!lang) {
                setLang(language || 'ru');
            }
            if (language && language !== lang && i18next.languages.some(it => it === lang)) {
                setLang(language);
                await i18next.changeLanguage(language);
            }

            if (channel) {
                setChannelId(channel);
            }
            if (phone) {
                setPhone(phone);
            }
            if (channelUserId) {
                setChannelUserId(channelUserId);
            }
            if (tariff_id) {
                setTariffId(tariff_id);
            }
        }
    }

    onOkAction = () => {
        const {channelId} = this.props;
        // if (localStorage.getItem('re-authorization') === ' true') {
        //     localStorage.setItem('re-authorization', 'false');
        //     history.push(`/services?user_id=${encodeURIComponent(userId)}&channel_id=${channelId}&lang=${lang}&tariff_id=${tariffId}`);
        // } else {
        //     history.push(`/services?user_id=${encodeURIComponent(userId)}&channel_id=${channelId}&lang=${lang}&tariff_id=${tariffId}`);
        //     location.href = messengerLinks[channelId];
        // }
        location.href = messengerLinks[channelId];
    }

    render() {
        document.title = i18next.t('successful_auth');
        const { channelId } = this.props;

        return (
            <SuccessView
                channelId={channelId}
                onOk={() => this.onOkAction()}
            />
        );
    }
}

export default withRouter(connect(mapProps, mapDispatch)(SuccessContainer));



// WEBPACK FOOTER //
// ./src/components/Authorization/Success/SuccessContainer.tsx